{
  "countryCode": "رمز الدولة",
  "choosePlaceholder": "اختر الدولة",
  "countrySearch": "ابحث عن دولة بالاسم أو الرمز",
  "noCountry": "لا توجد دولة مطابقة",
  "helper": "أدخل رقم خلوي",
  "errors": {
    "PHONE_REQUIRED": "رقم الهاتف مطلوب",
    "PHONE_INVALID": "رقم الهاتف غير صالح",
    "PHONE_NOT_MOBILE": "رقم أرضي غير مسموح، أدخل رقم خلوي",
    "PHONE_COUNTRY_NOT_ALLOWED": "أرقام هذه الدولة غير مقبولة"
  },
  "verification": {
    "title": "تأكيد رقم الهاتف",
    "sending": "جاري إرسال الرمز...",
    "sent": "تم إرسال رمز التحقق عبر واتساب إلى {{phone}}",
    "validity": "الرمز صالح لمدة {{minutes}} دقائق",
    "code": "رمز التحقق",
    "codeHelper": "أدخل الرمز الذي وصل إلى العميل",
    "verify": "تحقق",
    "verifying": "جاري التحقق...",
    "resend": "إعادة إرسال الرمز",
    "resendIn": "إعادة الإرسال بعد {{seconds}} ثانية",
    "changeNumber": "تغيير الرقم",
    "cancel": "إلغاء",
    "verified": "تم تأكيد رقم الهاتف",
    "wrongCode": "الرمز غير صحيح، تبقى {{count}} محاولات",
    "expired": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
    "attemptsExceeded": "تم تجاوز عدد المحاولات، اطلب رمزا جديدا",
    "sendLimit": "تم إرسال عدد كبير من الرموز لهذا الرقم، حاول بعد {{minutes}} دقيقة",
    "sendFailed": "تعذر إرسال رمز التحقق عبر واتساب ولم يتم الحفظ. حاول مجددا، أو يمكن للمسؤول إيقاف تأكيد الرقم من الإعدادات",
    "notOnWhatsapp": "تعذر تسليم الرسالة، الرقم غير مسجل في واتساب أو لا يقبل الرسائل",
    "unavailable": "تعذر التحقق من الرقم لدى نظام العملاء ولم يتم الحفظ، حاول مجددا",
    "verifiedBadge": "رقم مؤكد",
    "unverifiedBadge": "رقم غير مؤكد"
  }
}
